import { render, staticRenderFns } from "./SalesNew_Total.vue?vue&type=template&id=86fdf51c&"
import script from "./SalesNew_Total.vue?vue&type=script&lang=js&"
export * from "./SalesNew_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports